import { WORKFLOW_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';

const _axios = HttpService.getAxiosClient();

export const getCasualLeaveAccounting = async (userId, year) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/casual-leave-accounting/${year}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const quarterStatusLabel = (quarter) => {
  if (quarter.currentQuarter) {
    return 'Current';
  }
  if (quarter.status === 'FINALIZED') {
    return 'Completed';
  }
  if (quarter.status === 'PROVISIONAL') {
    return quarter.futureQuarter ? 'Upcoming' : 'Expected';
  }
  if (quarter.status === 'GRANTED') {
    return 'Granted';
  }
  return quarter.status;
};

export const allocationSummary = (quarter) => {
  const days = quarter.effectiveAllocationDays ?? 0;
  if (quarter.adminAdjustmentDays > 0) {
    return `${days} days (includes ${quarter.adminAdjustmentDays} additional)`;
  }
  if (
    quarter.status === 'PROVISIONAL' &&
    quarter.potentialAllocationDays != null
  ) {
    return `${quarter.potentialAllocationDays} days expected (not spendable)`;
  }
  return `${days} days`;
};

/**
 * Full current-quarter entitlement pool for user-facing cards:
 * grant + admin + rolled leftovers + year CF (matches backend entitlement).
 * effectiveAllocationDays alone is only this quarter's grant+admin and hides leftovers.
 */
export const currentQuarterEntitledDays = (quarter) => {
  if (!quarter) {
    return 0;
  }
  if (
    quarter.status === 'PROVISIONAL' &&
    quarter.potentialAllocationDays != null
  ) {
    return quarter.potentialAllocationDays;
  }
  return (
    (quarter.effectiveAllocationDays ?? 0) +
    (quarter.accumulatedInDays ?? 0) +
    (quarter.yearCfAppliedDays ?? 0) -
    (quarter.deficitCarriedInDays ?? 0)
  );
};

/** Current-quarter entitled + availed for simple user-facing leave cards. */
export const getCurrentQuarterCasualStats = (snapshot) => {
  if (!snapshot) {
    return null;
  }
  const currentQuarter =
    snapshot.quarters?.find((q) => q.currentQuarter) || null;
  const quarter = snapshot.currentQuarter ?? currentQuarter?.quarter ?? null;
  const entitled = currentQuarterEntitledDays(currentQuarter);
  const availed = currentQuarter?.usageDays ?? 0;
  return { quarter, entitled, availed };
};
